module.exports = __webpack_public_path__ + "img/correct.c62e2f4e.svg";